"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 导出失败的 Icon
 * url: https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/75867d74-3424-4216-88fb-7acc80c19641
 * name: IcUploadImage
 */
function IcUploadImage() {
    return null;
}
exports.default = IcUploadImage;
;
